// ========================================================================
// fileService.ts 내용 시작 (xstate/services 경로)
// ========================================================================

// 필요한 import 추가 (예: useStorage)
import { useStorage } from '@/composables/useStorage';
import type { UploadFileInput, UploadFileOutput, IFileService } from '@wowpress/state-machine';

/**
 * Firebase Storage를 사용하는 파일 서비스 구현체
 */
export class FirebaseFileService implements IFileService { // Implement interface from package
  async uploadFile(input: UploadFileInput, ticketId?: string): Promise<UploadFileOutput> { // Use types from package
    if (!input?.file) {
      throw new Error("파일이 제공되지 않았습니다.");
    }

    // !!주의: useStorage composable 의존성!
    const { uploadFile } = useStorage(); 

    const path = ticketId ? `tickets/${ticketId}/attachments/${Date.now()}_${input.file.name}` : `uploaded-files/${input.file.name}`; 

    
    try {
        const downloadURL = await uploadFile(input.file, {
          path,
          metadata: {
            customMetadata: {
              uploadedBy: 'chatbot-customer',
              purpose: 'chat-upload'
            }
          },
          generateUniqueName: true 
        });
    
        if (!downloadURL) {
          throw new Error("파일 업로드 후 URL을 받지 못했습니다.");
        }
    
        return {
          fileUrl: downloadURL,
          message: "파일 업로드가 완료되었습니다."
        };
    } catch (error) {
        console.error("[FirebaseFileService] File upload failed:", error);
        const errorMessage = error instanceof Error ? error.message : "알 수 없는 오류로 업로드에 실패했습니다.";
        throw new Error(`파일 업로드 실패: ${errorMessage}`);
    }
  }
}

// ========================================================================
// fileService.ts 내용 끝
// ======================================================================== 